import type {
  AllExclusiveListingResults, AllOffMarketResults, CallListItem, InsightsProperty
} from 'bundles/connect/types';
import { SET_RESULTS } from '../actions/results';

type ResultsState = {
  callListItems?: CallListItem[];
  allResults?: AllExclusiveListingResults[],
  detailedResults?: any[],
  offMarketResults?: InsightsProperty[],
  allOffMarketResults?: AllOffMarketResults[],
  totalOffMarketResults: null,
  page: 1,
  totalPages: 1
}

export default function(
  // TODO: allResults is basically offMarketResults but for exclusive listing - we should name this better
  state: ResultsState = {
    allResults: undefined,
    detailedResults: undefined,
    offMarketResults: undefined,
    allOffMarketResults: undefined,
    totalOffMarketResults: null,
    page: 1,
    totalPages: 1
  },
  action
): ResultsState {
  switch (action.type) {
  case SET_RESULTS:
    return { ...state, ...action.payload };
  default:
    return state;
  }
}
